import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '../../core/services/translation.service';

@Pipe({
  name: 't',
  pure: false
})
export class TranslatePipe implements PipeTransform {
  constructor(private translations: TranslationService) {}

  transform(value: string): string {
    return this.translations.translate(value);
  }
}
